import * as loadQueueHelper from '../../../js/document/load-queue'
import ReviewsList from './main'

loadQueueHelper.add(function () {
  ReviewsList.createInstancesOnDocument()
})
